import { getLanguage } from '@home/utils/common';
import type { IColumnInfo } from '@dbl/core/dataSource';

export function buildText(values: any[], options: any[], isEn: boolean) {
  const safeValues = values || [];
  const safeOptions = options || [];
  let text = '';
  if (safeValues.length === safeOptions.length || safeOptions.length === 0) {
    text = isEn ? "All" : '全部';
  } else if (safeValues.length <= 2 && safeValues.length > 0) {
    text = safeOptions
      .filter((item) => safeValues.includes(item.value))
      .map((item) =>
        getLanguage(isEn, item.text_en, item.text),
      )
      .join(',');
  } else if (safeValues.length === 0) {
    text = `-`;
  } else {
    text = `${safeValues.length}`;
  }
  return text;
}

export function getFlatOptions(options: any[]) {
  return options
    .flatMap((menu) => menu.list.flatMap((tab: any) => tab.options))
    .reduce((previous, current) => {
      if (previous.some((item: any) => item.value === current.value)) {
        return previous;
      }
      previous.push(current);
      return previous;
    }, []);
}

// 获取第一个没有被选择的Column
export function getFirstColumn(all: IColumnInfo[], selected: IColumnInfo[], flatOptions: any[]) {
  const option = flatOptions.find((item) => !selected.some((it) => it.column_name === item.value));
  if (option === undefined) {
    return undefined;
  }
  return all.find((item) => item.column_name === option.value);
}

export function generateAllMenu(options: any[]) {
  const allMenu: { menu_id: string; menu_name: string; list: any[]; } = {
    menu_id: 'all',
    menu_name: '全部',
    list: [],
  };

  options.forEach((menu: any) => {
    menu.list.forEach((tab: any) => {
      let findTab: any = allMenu.list.find((tabItem: any) => tabItem.tab_id === tab.tab_id);
      if (!findTab) {
        findTab = {
          ...tab,
          options: [],
        };
        allMenu.list.push(findTab);
      }
      tab.options.forEach((opt: any) => {
        if (!findTab.options.some((findOpt: any) => findOpt.value === opt.value)) {
          findTab.options.push(opt);
        }
      });
    });
  });
  return [allMenu, ...options];
}

export function tryAddNotExist(list: any[], elem: any, listKey: string, elemKey: string) {
  // 如果不存在就添加
  if (list.some((item) => item[listKey] === elem[elemKey]) === false) {
    list.push(elem);
  }
}
